/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Vakanties_Een_DagInputs */

const nl_planning_vakanties_een_dag = /** @type {(inputs: Planning_Vakanties_Een_DagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eén dag? Klik die dag twee keer aan.`)
};

/**

* @param {Planning_Vakanties_Een_DagInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_een_dag = /** @type {((inputs?: Planning_Vakanties_Een_DagInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_Een_DagInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_een_dag(inputs)
});
export { planning_vakanties_een_dag as "planning.vakanties.een_dag" }